import { Directive } from '@angular/core';
import { DynamicItemBaseComponent } from '../dynamic-item/dynamic-item.base-component';

@Directive()
export abstract class DynamicRedactedBaseComponent extends DynamicItemBaseComponent {
  isRedacted = true;
}
